import { SidebarStoryFrame, ReactLightbox } from 'Elements';

export const SidebarStoryImage = ({ image, hasMore, onShowMore }) => {
	return (
		<SidebarStoryFrame
			type="image"
			hasMore={hasMore}
			onShowMore={onShowMore}>
			<ReactLightbox images={image} />
		</SidebarStoryFrame>
	);
};
